// Содержимое читалки косяка (карточка по наведению на маркер). Форма правки
// показывает те же поля виджетами; здесь — готовые строки, без ввода.

import type { Cluster, SpeciesItem } from '../api'
import { formatDayTime, getLang, speciesName, t } from '../i18n'
import { SIZE_OPTIONS } from './clusterDraft'

/** Смещение из ISO-строки в минутах: «…+11:00» → 660, «…Z» → 0, без хвоста → null. */
function offsetMinutes(iso: string): number | null {
  const m = /(Z|[+-]\d{2}:?\d{2})$/.exec(iso)
  if (!m) return null
  if (m[1] === 'Z') return 0
  const sign = m[1][0] === '-' ? -1 : 1
  const [hh, mm] = m[1].slice(1).replace(':', '').match(/\d{2}/g)!.map(Number)
  return sign * (hh * 60 + mm)
}

/** Дата и время в поясе САМОЙ отметки: судовое время важнее часового пояса
 *  браузера — отметку ставили на промысле, читают её нередко из Москвы.
 *
 *  Сдвигаем момент на пояс отметки и печатаем его как UTC: формат даёт Intl по
 *  языку кабинета, а не ручная склейка с русскими названиями месяцев. */
function whenLabel(iso: string | null): string {
  if (!iso) return '—'
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return '—'
  // Пояс отметки неизвестен → показываем в поясе браузера (тот же сдвиг, только
  // взятый у него): совсем без сдвига время «уехало» бы в UTC.
  const shift = offsetMinutes(iso) ?? -d.getTimezoneOffset()
  return formatDayTime(getLang(), new Date(d.getTime() + shift * 60_000).toISOString())
}

export interface ClusterPeekLines {
  title: string
  size: string
  when: string
  note: string | null
}

export function clusterPeekLines(cluster: Cluster, species: SpeciesItem[]): ClusterPeekLines {
  const found = species.find(s => s.species_id === cluster.species_id)
  const name = found ? speciesName(found, getLang()) : undefined
  const sizeKey = SIZE_OPTIONS.find(o => o.value === cluster.size_class)?.labelKey
  const size = sizeKey ? t(sizeKey) : '—'
  const note = cluster.note?.trim()
  return {
    title: name ? `${t('models.cluster.title')} · ${name}` : t('models.cluster.title'),
    size,
    when: whenLabel(cluster.observed_at),
    note: note ? note : null,
  }
}
